<template>
  <vx-card title="Última Localização">
    <div>{{ dispositivo.location_update_at | formatDateTime }}</div>
    <l-map :zoom="map.zoom" :center="map.center" style="height: 340px; z-index: 0">
      <l-tile-layer :url="map.url" :attribution="map.attribution" />
      <l-marker :icon="m.icon" :lat-lng="m.pointer" v-for="m in map.markers" :key="m.id">
        <l-tooltip>
          {{ m.dateTime | formatDateTime }}
          <br />
          {{ m.address }}
          <br v-show="m.address" />
          {{m.pointer.lat}},{{m.pointer.lng}}
        </l-tooltip>
      </l-marker>
    </l-map>
  </vx-card>
</template>

<script>
import L from "leaflet";

export default {
  props: {
    dispositivo: Object
  },
  data() {
    return {
      map: {
        zoom: 17,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution: "",
        center: L.latLng(0, 0),
        currentCenter: L.latLng(0, 0),
        currentZoom: 17,
        markers: []
      }
    };
  },
  watch: {
    dispositivo: function() {
      if (this.dispositivo) {
        var latLng = L.latLng(
          this.dispositivo.latitude,
          this.dispositivo.longitude
        );

        this.map.center = latLng;
        this.map.currentCenter = latLng;
        this.map.markers = [
          {
            dateTime: this.dispositivo.location_update_at,
            pointer: latLng
          }
        ];
      }
    }
  }
};
</script>
